import { Component, OnInit } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-avatar',
  templateUrl: './app-avatar.component.html',
})
export class AppAvatarComponent extends FieldComponent implements OnInit {
  style: string;
  attributes: any;
  override start() {
    super.start();
    this.attributes = this.field?.customAttributes;
  }
}
